import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { InterfaceEmployee } from 'app/models/employee.model';
import { EmployeeService } from 'app/services/employee.service';
import { SweetalertService } from 'app/services/sweetalert.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent implements OnInit, OnDestroy {

  loginFormSubmitted = false;
  isLoginFailed = false;
  loginForm = new FormGroup({
    email: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required),
    keepLogin: new FormControl(null, Validators.nullValidator)
  });
  employee: InterfaceEmployee = {};
  currentUserId = "";
  isLogin = false;
  loginFormSub = new Subscription();

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    protected firebaseAuth: AngularFireAuth,
    protected employeeService: EmployeeService,
    protected swal: SweetalertService) {
  }

  get lf() {
    return this.loginForm.controls;
  }

  ngOnInit(): void {
    const keepLogin = localStorage.getItem("keepLogin");
    if (keepLogin) {
      this.firebaseAuth.authState.pipe(take(1)).subscribe((user) => {
        if (user) {
          this.router.navigateByUrl("display");
        }
      });
    }
    this.loginFormSub = this.loginForm.controls.keepLogin.valueChanges.subscribe((newValue: any) => {
      localStorage.setItem("keepLogin", newValue);
    }, (error: any) => {
      console.error(error);
      this.spinner.hide();
    });
  }

  ngOnDestroy(): void {
    this.loginFormSub.unsubscribe();
  }

  // On submit button click
  onSubmit() {
    this.isLogin = true;
    this.spinner.show(undefined,
      {
        type: 'square-jelly-box',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.firebaseAuth.signInWithEmailAndPassword(this.loginForm.value.email, this.loginForm.value.password).then((result: any) => {
      localStorage.setItem("userId", result.user!.uid);
      this.currentUserId = result.user!.uid;
      this.getEmployeeInformation();
    }).catch((error: any) => {
      this.spinner.hide();
      console.error("Error signin =>", error);
      this.isLogin = false;
      this.swal.showError();
    });
  }

  getEmployeeInformation(): void {
    this.employeeService.getEmployeeInformation(this.currentUserId).pipe(take(1)).subscribe((resultEmployee: any) => {
      this.spinner.hide();
      this.employee = resultEmployee;
      localStorage.setItem("userName", this.employee.name + " " + this.employee.lastName);
      localStorage.setItem("role", this.employee.role!);
      this.router.navigateByUrl("display");
    }, (error: any) => {
      console.error(error);
      this.spinner.hide();
    });
  }

}
